import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import ChipSelector, { ChipOption } from "../../../common/form/ChipSelect/ChipSelector";
import CustomDropdown from "../../../common/general/CustomDropDown/CustomDropdown";
import CustomText from "../../../common/general/CustomText/CustomText";
import { spacing, colors } from "../../../../styles/design-system";
import { useTranslation } from "react-i18next";

interface Value {
  motivations: string[];
  semesterGoal: string;
}

interface Props {
  value: Value;
  onChange: (v: Value) => void;
}

export default function MotivationEditor({ value, onChange }: Props) {
  const { t } = useTranslation();

  const motivationOptions: ChipOption[] = useMemo(
    () => [
      { key: "better_grades", value: t("text.companion_onboarding_motivation_grades") },
      { key: "deep_understanding", value: t("text.companion_onboarding_motivation_understanding") },
      { key: "more_confidence", value: t("text.companion_onboarding_motivation_confidence") },
      { key: "learning_faster", value: t("text.companion_onboarding_motivation_learning_faster") },
    ],
    [t]
  );

  const goalOptions = [
    { value: "pass_finals", label: t("text.companion_onboarding_goal_pass_finals") },
    { value: "improve_gpa", label: t("text.companion_onboarding_goal_improve_gpa") },
    { value: "complete_prerequisites", label: t("text.companion_onboarding_goal_complete_prerequisites") },
    { value: "stay_on_track", label: t("text.companion_onboarding_goal_stay_on_track") },
  ];

  return (
    <View style={styles.container}>
      <CustomText
        style={{ color: colors.grey[500], marginBottom: spacing.xxs }}
        text="companion_onboarding_step5_motivations_label"
        size="xs"
        weight="bold"
      />
      <View style={{ marginBottom: spacing.lg }}>
        <ChipSelector
          options={motivationOptions}
          selectedKeys={value?.motivations ?? []}
          onSelectionChange={(v) => onChange({ ...value, motivations: v })}
          multiSelect
        />
      </View>

      <CustomText
        style={{ color: colors.grey[500], marginBottom: spacing.xxs }}
        text="companion_onboarding_step5_goal_label"
        size="xs"
        weight="bold"
      />
      <View style={{ position: "relative", zIndex: 9999 }}>
        <CustomDropdown
          options={goalOptions}
          value={value?.semesterGoal ?? ""}
          onChange={(v) => onChange({ ...value, semesterGoal: v })}
          placeholder={t("text.companion_onboarding_step5_goal_placeholder")}
          containerStyle={{ width: "100%", marginBottom: spacing.xxs }}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing.xxs,
  },
});
